import React from 'react';

const LoadingFull = ({ text }: { text?: string }) => {
  return (
    <div className="absolute min-h-full w-full flex flex-col justify-center items-center bg-base/80 z-[99999999999999999999]">
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-colors-green -mt-32"></div>
    </div>
  );
};

export default LoadingFull;
